import styled, {css} from 'styled-components'

export const StyledMonthGrid = styled.table<{$isRange: boolean}>(
    ({theme: {spacing}, $isRange}) => css`
        border-collapse: separate;
        border-spacing: ${!$isRange ? spacing * 1 : 0}px;
    `
)
